export default (params) => ({
    state: params.state ?? false,
    search: null,
    wireModel: params.wireModel,
    isCloseable: params.isCloseable ?? true,
    init() {
        const _this = this;
        if (this.wireModel) {
            this.state = true
            this.search = this.wireModel
        }

        this.$watch('search', ((value) => {
            _this.wireModel = value
        }));
    },
    focus () {
        this.$refs.input.focus()
    },
    close () {
        if (this.$refs.input.value === '' && this.isCloseable) {
            this.state = false
        }
    },
    clear () {
        this.search = '';
    },
    toggle () {
        this.state = !this.state
        if (this.state) {
            this.$nextTick(() => setTimeout(() => this.focus(), 100))
        }
    }
})
